import { CheckCircle2, CloudOff, CloudUpload } from 'lucide-react';
import { usePreinvoice } from '../context/PreinvoiceContext';

export default function CartSyncStatus() {
  const { syncStatus } = usePreinvoice();
  if (syncStatus === 'local') return null;
  const saved = syncStatus === 'synced';
  const offline = ['offline', 'error'].includes(syncStatus);
  const Icon = saved ? CheckCircle2 : offline ? CloudOff : CloudUpload;
  return <div role="status" aria-live="polite" className={`mt-1 inline-flex items-center gap-1 text-[11px] ${saved ? 'text-emerald-700' : offline ? 'text-amber-700' : 'text-slate-500'}`}><Icon size={13} /><span>{saved ? 'ذخیره و همگام شد' : offline ? 'ذخیره نشده؛ در انتظار اتصال' : syncStatus === 'loading' ? 'دریافت سبد...' : 'در حال ذخیره...'}</span></div>;
}
